
import { setShowTrustBuilderPopup } from '../appSlice';
import { parseStringToJson } from './helpers';

const showTrustBuilder = (dispatch) => {
    const { default_photo_url, locale } = window.holidayFinder;
    const settings = parseStringToJson(default_photo_url)?.[locale]?.[0]?.trustBuilder;
  
    const { postWizardTimer } = settings || {};

    setTimeout(() => {
      if (!localStorage.getItem('popupShown')) {
        dispatch(setShowTrustBuilderPopup(true));
      }
    }, +postWizardTimer * 1000 || 7 * 1000);
  }
  
export default showTrustBuilder